var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('router-link',{staticClass:"iv2__top-btn theme__main-btn is-btn is-btn-ghost2 size-18",attrs:{"to":'/' + _vm.lang + _vm.query}},[_vm._v(_vm._s(_vm.$store.state.publicLang.general.top_btn))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }